/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { shopOrderControllerCreate } from '../fn/shop-order/shop-order-controller-create';
import { ShopOrderControllerCreate$Params } from '../fn/shop-order/shop-order-controller-create';
import { shopOrderControllerFindById } from '../fn/shop-order/shop-order-controller-find-by-id';
import { ShopOrderControllerFindById$Params } from '../fn/shop-order/shop-order-controller-find-by-id';
import { shopOrderControllerFindMyOrder } from '../fn/shop-order/shop-order-controller-find-my-order';
import { ShopOrderControllerFindMyOrder$Params } from '../fn/shop-order/shop-order-controller-find-my-order';
import { shopOrderControllerGetStats } from '../fn/shop-order/shop-order-controller-get-stats';
import { ShopOrderControllerGetStats$Params } from '../fn/shop-order/shop-order-controller-get-stats';
import { shopOrderControllerSearch } from '../fn/shop-order/shop-order-controller-search';
import { ShopOrderControllerSearch$Params } from '../fn/shop-order/shop-order-controller-search';
import { shopOrderControllerSearchMy } from '../fn/shop-order/shop-order-controller-search-my';
import { ShopOrderControllerSearchMy$Params } from '../fn/shop-order/shop-order-controller-search-my';
import { shopOrderControllerUpdateMemo } from '../fn/shop-order/shop-order-controller-update-memo';
import { ShopOrderControllerUpdateMemo$Params } from '../fn/shop-order/shop-order-controller-update-memo';
import { shopOrderControllerUpdateTracking } from '../fn/shop-order/shop-order-controller-update-tracking';
import { ShopOrderControllerUpdateTracking$Params } from '../fn/shop-order/shop-order-controller-update-tracking';
import { ShopOrderDetailDto } from '../models/shop-order-detail-dto';
import { ShopOrderDto } from '../models/shop-order-dto';
import { ShopOrderStatsDto } from '../models/shop-order-stats-dto';

@Injectable({ providedIn: 'root' })
export class ShopOrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopOrderControllerSearch()` */
  static readonly ShopOrderControllerSearchPath = '/api/shop-orders';

  /**
   * 주문 목록 조회 (관리자).
   *
   * 전체 주문 목록을 페이지 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerSearch$Response(params: ShopOrderControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopOrderControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 목록 조회 (관리자).
   *
   * 전체 주문 목록을 페이지 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerSearch(params: ShopOrderControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopOrderControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerCreate()` */
  static readonly ShopOrderControllerCreatePath = '/api/shop-orders';

  /**
   * 단건 주문 생성 (클라이언트).
   *
   * 쇼핑몰 단건 상품 주문(옵션 선택 포함)을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerCreate$Response(params: ShopOrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
    const obs = shopOrderControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 단건 주문 생성 (클라이언트).
   *
   * 쇼핑몰 단건 상품 주문(옵션 선택 포함)을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerCreate(params: ShopOrderControllerCreate$Params, context?: HttpContext): Observable<ShopOrderDto> {
    const resp = this.shopOrderControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDto>): ShopOrderDto => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerGetStats()` */
  static readonly ShopOrderControllerGetStatsPath = '/api/shop-orders/stats';

  /**
   * 쇼핑몰 통계 조회 (관리자).
   *
   * 오늘 매출, 배송 대기, 상품 현황, 7일 매출 추이를 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerGetStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerGetStats$Response(params?: ShopOrderControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderStatsDto>> {
    const obs = shopOrderControllerGetStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 쇼핑몰 통계 조회 (관리자).
   *
   * 오늘 매출, 배송 대기, 상품 현황, 7일 매출 추이를 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerGetStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerGetStats(params?: ShopOrderControllerGetStats$Params, context?: HttpContext): Observable<ShopOrderStatsDto> {
    const resp = this.shopOrderControllerGetStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderStatsDto>): ShopOrderStatsDto => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerSearchMy()` */
  static readonly ShopOrderControllerSearchMyPath = '/api/shop-orders/my';

  /**
   * 내 주문 목록 조회 (클라이언트).
   *
   * 로그인한 사용자의 주문 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerSearchMy()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerSearchMy$Response(params: ShopOrderControllerSearchMy$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopOrderControllerSearchMy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 주문 목록 조회 (클라이언트).
   *
   * 로그인한 사용자의 주문 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerSearchMy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerSearchMy(params: ShopOrderControllerSearchMy$Params, context?: HttpContext): Observable<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopOrderControllerSearchMy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerFindMyOrder()` */
  static readonly ShopOrderControllerFindMyOrderPath = '/api/shop-orders/my/{id}';

  /**
   * 내 주문 상세 조회 (클라이언트).
   *
   * 로그인한 사용자의 특정 주문 상세를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerFindMyOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerFindMyOrder$Response(params: ShopOrderControllerFindMyOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderControllerFindMyOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 주문 상세 조회 (클라이언트).
   *
   * 로그인한 사용자의 특정 주문 상세를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerFindMyOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerFindMyOrder(params: ShopOrderControllerFindMyOrder$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderControllerFindMyOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerFindById()` */
  static readonly ShopOrderControllerFindByIdPath = '/api/shop-orders/{id}';

  /**
   * 주문 상세 조회 (관리자).
   *
   * 주문 ID로 상세 정보와 주문 상품 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerFindById$Response(params: ShopOrderControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 상세 조회 (관리자).
   *
   * 주문 ID로 상세 정보와 주문 상품 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderControllerFindById(params: ShopOrderControllerFindById$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerUpdateTracking()` */
  static readonly ShopOrderControllerUpdateTrackingPath = '/api/shop-orders/{id}/tracking';

  /**
   * 송장번호 등록 (관리자).
   *
   * 택배사와 송장번호를 등록합니다. 주문 상태가 DELIVERED로 자동 전환됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerUpdateTracking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerUpdateTracking$Response(params: ShopOrderControllerUpdateTracking$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderControllerUpdateTracking(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 송장번호 등록 (관리자).
   *
   * 택배사와 송장번호를 등록합니다. 주문 상태가 DELIVERED로 자동 전환됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerUpdateTracking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerUpdateTracking(params: ShopOrderControllerUpdateTracking$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderControllerUpdateTracking$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

  /** Path part for operation `shopOrderControllerUpdateMemo()` */
  static readonly ShopOrderControllerUpdateMemoPath = '/api/shop-orders/{id}/memo';

  /**
   * 주문 메모 수정 (관리자).
   *
   * 관리자 전용 메모를 수정합니다. (환불 사유 등)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderControllerUpdateMemo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerUpdateMemo$Response(params: ShopOrderControllerUpdateMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderControllerUpdateMemo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 메모 수정 (관리자).
   *
   * 관리자 전용 메모를 수정합니다. (환불 사유 등)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderControllerUpdateMemo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderControllerUpdateMemo(params: ShopOrderControllerUpdateMemo$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderControllerUpdateMemo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

}
